import { getEnvVariables } from '@openx/utils/services/optionsService';
import { useTranslation } from 'react-i18next';

import pckg from '../package.json';

export const TIMEOUT_BEFORE_REDIRECT = 100;

const parsedEnvValues = getEnvVariables();
export const TABLE_PAGE_SIZE: number = parsedEnvValues.tablePageSize;
export const DV360_DEMAND_PARTNER_ID = parsedEnvValues.dv360DemandPartnerId;

export const APP_VERSION = pckg.version;
export const OA_VERSION = pckg.version;

export const SKIP_AUTH = !!import.meta.env.VITE_NX_PUBLIC_REACT_APP_SKIP_AUTH;
export const OA_UI_MODE = import.meta.env.VITE_NX_PUBLIC_REACT_APP_OA_UI_MODE;
export const CREATIVE_SANDBOX_URL =
  import.meta.env.VITE_NX_PUBLIC_CREATIVE_SANDBOX_URL ?? parsedEnvValues.creativeSandboxUrl ?? '';

export const ROLLBAR_ACCESS_TOKEN = 'b7a085a6be28475d85f0ccd67fa72402';

export const GROWTHBOOK_API_HOST = parsedEnvValues.growthbookApiHost;
export const GROWTHBOOK_API_KEY = parsedEnvValues.growthbookApiKey;
export const GROWTHBOOK_SALT = 'qA&@?C7Zfp#DS88pWzKtdBiZXtK2z9a3o8cB';
export const GROWTHBOOK_NAME_ATTR = `${pckg.name}`;

export const useGetNotAllowedMsg = () => {
  const { t } = useTranslation();
  return t('You need permission to perform this action');
};

export const ENV_CONFIGS_PATH = '/configs.json';
export const developmentConfig = {
  env: 'devint',
  firebase: {
    apiKey: 'AIzaSyCar0TQ-ZpY_PVaHlwESUy83RynnyVmQRk',
    authDomain: 'ox-identity-provider-devint.firebaseapp.com',
    databaseURL: 'https://ox-identity-provider-devint.firebaseio.com',
    projectId: 'ox-identity-provider-devint',
    storageBucket: 'ox-identity-provider-devint.appspot.com',
  },
};

export const PENDO_API_KEY = parsedEnvValues.pendoApiKey;
